import { useMemo } from 'react';
// tslint:disable-next-line:import-blacklist
import { useHistory } from 'react-router-dom';
import { useConfig } from '../../../../context';
import { mapRoutePath } from './mapRoutePath';
export function useHistoryWrapper() {
    var _a;
    const history = useHistory();
    const enabled = (_a = useConfig().global.alternativeRouting) !== null && _a !== void 0 ? _a : false;
    return useMemo(() => {
        if (!enabled) {
            return history;
        }
        const wrap = (to) => {
            if (typeof to === 'string') {
                return mapRoutePath(to, true);
            }
            if (to && typeof to === 'object' && typeof to.pathname === 'string') {
                return Object.assign(Object.assign({}, to), { pathname: mapRoutePath(to.pathname, true) });
            }
            return to;
        };
        return new Proxy(history, {
            get(target, prop, receiver) {
                if (prop === 'push' || prop === 'replace') {
                    return (to, state) => target[prop](wrap(to), state);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
    }, [history, enabled]);
}
